<template>
  <div id="divPayment">
    <div class="Flex_Table tblEntryForm">
      <div class="Flex_Row">
        <div class="Flex_Cell Entry" style="width: 25%" v-if="userTypeID == 2 || userTypeID == 5">
          <fieldset>
            <div class="Flex_Table tblEntryForm" style="height: calc(100vh - 160px);overflow: auto">
              <div class="Flex_Row">
                <div class="Flex_Cell" style="width: 100%">
                  <span class="mandatorySpan" :class="{ Required: true }">Reason</span>
                  <SearchDropDown
                    v-bind:list-data="reasonList"
                    value-field="reasonTypeID"
                    firstItem="-- Select One --"
                    text-field="reasonTypeName"
                    v-model="reasonTypeID"
                  ></SearchDropDown>
                </div>
              </div>
              <div class="Flex_Row">
                <div class="Flex_Cell" style="width: 100%">
                  <span class="mandatorySpan" :class="{ Required: true }">Amount [in Rupee]</span>
                  <AcceptInput
                    maxlength="10"
                    ref="amount"
                    type="textbox"
                    placeholder="PLEASE ENTER AMOUNT (IN RUPEE)"
                    v-model="amount"
                    class="CreateAccount"
                    regExp="([0-9])*"
                  />
                </div>
              </div>
              <div class="Flex_Row">
                <div class="Flex_Cell" style="width: 100%">
                  <span class="mandatorySpan" :class="{ Required: false }">From</span>
                  <DateControl style="width: 100%" v-model="fromDate"></DateControl>
                </div>
              </div>
              <div class="Flex_Row">
                <div class="Flex_Cell" style="width: 100%">
                  <span class="mandatorySpan" :class="{ Required: false }">To</span>
                  <DateControl style="width: 100%" v-model="toDate"></DateControl>
                </div>
              </div>
              <div class="Flex_Row">
                <div class="Flex_Cell" style="width: 100%">
                  <span class="mandatorySpan" :class="{ Required: false }">Payment Remark</span>
                  <textarea
                    ref="PaymentRemark"
                    v-model="remark"
                    placeholder="ENTER PAYMENT REMARK"
                    title="ENTER PAYMENT REMARK"
                    maxlength="500"
                    v-on:keypress="validatePaymentRemark($event)"
                    @click.right.prevent
                    @copy.prevent
                    @paste.prevent
                    regExp="([A-Z ' ,-/&@*()'a-z0-9])*"
                  ></textarea>
                </div>
              </div>
              <div class="Flex_Row">
                <div class="Flex_Cell" style="width: 100%">
                  <span class="mandatorySpan" :class="{ Required: false }">Upload Document</span>
                  (File must be in .jpg /.jpeg /.png /.pdf format and size between 10 to 100 kb only.)
                  <input
                    type="file"
                    id="FileBox"
                    v-on:change="getFileData($event)"
                  />
                  <!-- <span>{{ imageFileName }}</span> -->
                </div>
              </div>
              <div class="Flex_Row">
                <div class="Flex_Cell" style="width: 50%">
                  <span class="mandatorySpan" :class="{ Required: true }">Captcha</span>
                  <AcceptInput
                    maxlength="6"
                    ref="captchaValue"
                    type="textbox"
                    :isRequired="true"
                    placeholder="CAPTCHA"
                    v-model="captchaValue"
                    class="CreateAccount"
                    regExp="([A-Za-z0-9])*"
                  />
                </div>
                <div class="Flex_Cell" style="width: 35%" valign="bottom">
                  <img id="imgCaptcha" style="border: 1px solid #000" />
                </div>
                <div class="Flex_Cell" style="width: 10%" valign="bottom">
                  <img
                    src="../assets/images/refresh.png"
                    v-on:click="generateCaptcha()"
                    style="cursor: pointer;height: 25px;border: 1px solid #000;border-radius: 50%;"
                    title="Click here to refresh captcha"
                  />
                </div>
              </div>
              <div class="Flex_Row" align="right">
                <input
                  type="button"
                  style="padding: 5px 20px"
                  title="Save"
                  value="Pay Now"
                  @click="PayNow()"
                />
                <input
                  type="button"
                  style="padding: 5px 20px"
                  title="Clear"
                  value="Clear"
                  @click="ClearPaymentDetails()"
                />
              </div>
            </div>
          </fieldset>
        </div>
        <div class="Flex_Cell Entry">
          <div class="Flex_Row">
            <fieldset>
              <div class="Flex_Table">
                <div class="Flex_Row">
                  <div class="Flex_Cell_Inline" v-if="userTypeID == 3">
                    <span>User Type</span>
                    <select id="ddlUserType" v-model="userTypeIDForddl" @change="getUserList()">
                      <option value="-1">---All---</option>
                      <option v-for="u in userType_List" :key="u[0]" v-bind:value="u[0]">{{ u[1] }}</option>
                    </select>
                  </div>
                  <div class="Flex_Cell" v-if="userTypeID == 3">
                    <span>
                      <input
                        type="checkbox"
                        v-model="isDeleted"
                        :id="'isDeleted'"
                        @change="getUserList()"
                      />
                      <label :for="'isDeleted'">Active User</label>
                    </span>
                    <select id="ddlUser" v-model="userIDForddl">
                      <option value="-1">---All---</option>
                      <option
                        v-for="u in user_List"
                        :key="u.userID"
                        v-bind:value="u.userID"
                      >{{ u.userName }}</option>
                    </select>
                  </div>
                  <div class="Flex_Cell_Inline">
                    <span>Status</span>
                    <select id="ddlStatus" v-model="status">
                      <option value="-1">---All---</option>
                      <option value="1">Paid</option>
                      <option value="0">Fail</option>
                    </select>
                  </div>
                  <div class="Flex_Cell">
                    <span>From Date</span>
                    <DateControl style="width: 100%" v-model="fromDateAdmin"></DateControl>
                  </div>

                  <div class="Flex_Cell">
                    <span>To Date</span>
                    <DateControl style="width: 100%" v-model="toDateAdmin"></DateControl>
                  </div>
                  <div class="Flex_Cell">
                    <input
                      type="button"
                      style="background-color: Green; padding: 10px"
                      value="Get"
                      @click="getTourOperatorPaymentDetailsList()"
                    />
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div class="Flex_Row">
            <fieldset>
              <div class="Flex_Table ekkGrid">
                <div class="Flex_Row GridHeader">
                  <div class="Flex_Cell" style="width: 7%">Sr.No.</div>
                  <div
                    class="Flex_Cell"
                    style="width: 10%"
                    v-if="userTypeID == 3 || userTypeID == 4"
                  >User Name</div>
                  <div class="Flex_Cell" style="width: 18%">Transaction No.</div>
                  <div class="Flex_Cell" style="width: 13%">Amount (in Rupees)</div>
                  <div class="Flex_Cell" style="width: 8%">Status</div>
                  <div class="Flex_Cell" style="width: 25%">Remark</div>
                  <div class="Flex_Cell" style="width: 12%">Payment Date</div>
                  <div class="Flex_Cell">Uploaded File</div>
                </div>
                <div class="GridContent" style="height: calc(100vh - 200px)">
                  <div
                    class="Flex_Row"
                    style="min-height: 35px"
                    v-for="(row, index) in tourOperatorPaymentDetailsList"
                    :key="index"
                  >
                    <div
                      class="Flex_Cell"
                      align="center"
                      valign="middle"
                      style="width: 7%"
                    >{{ index + 1 }}</div>
                    <div
                      class="Flex_Cell"
                      align="center"
                      valign="middle"
                      v-if="userTypeID == 3 || userTypeID == 4"
                      style="width: 10%"
                    >{{ row.tourOperatorName }}</div>
                    <div
                      class="Flex_Cell"
                      align="center"
                      valign="middle"
                      style="width: 18%"
                    >{{ row.receiptNo != "" ? row.receiptNo : "-" }}</div>
                    <div
                      class="Flex_Cell"
                      align="center"
                      valign="middle"
                      style="width: 13%"
                    >Rs. {{ Number(row.paymentAmount).toFixed(2) }}</div>
                    <div class="Flex_Cell" align="center" valign="middle" style="width: 8%">
                      {{
                      row.isPaymentDone == 0
                      ? "Failed"
                      : row.isPaymentDone == 2
                      ? "Pending"
                      : "Paid"
                      }}
                    </div>
                    <div
                      class="Flex_Cell"
                      align="center"
                      valign="middle"
                      style="width: 25%"
                    >{{ row.remark }}</div>
                    <div
                      class="Flex_Cell"
                      align="center"
                      valign="middle"
                      style="width: 12%"
                    >{{ new Date(row.receiptDate).convertToString("dd MMM yyyy") != "01 Jan 1900" ? new Date(row.receiptDate).convertToString("dd MMM yyyy") : "-" }}</div>
                    <div class="Flex_Cell" align="center" valign="middle">
                      <div
                        class="Flex_Row"
                        v-for="(file, i) in row.getTourOperatorPaymentDocs"
                        :key="i"
                      >
                        <a @click="openScanImage(file)" v-if="file.documentFileExtension != 'pdf'">
                          <span>{{ file.documentFileName }}</span>
                        </a>
                        <a
                          v-else
                          download
                          :href="'data:application/pdf;base64,' + file.documentFile"
                        >
                          <span>{{ file.documentFileName }}</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoginJs from "../components/servicesJS/Login.js";
import PaymentPortal from "../components/servicesJS/PaymentPortal.js";
import SearchDropDown from "../components/ekkControls/SearchDropDown.vue";
import AcceptInput from "../components/ekkControls/AcceptInput.vue";
import DateControl from "../components/ekkControls/DateControl.vue";
import FileUpload from "../components/ekkControls/FileUpload.vue";
import MasterEntryJS from "./servicesJS/MasterEntry.js";
import UserManagementJS from "./servicesJS/UserManagement.js";
export default {
  name: "PaymentPortal",
  components: {
    AcceptInput,
    SearchDropDown,
    DateControl,
    FileUpload
  },
  data() {
    return {
      reasonList: [],
      tourOperatorPaymentDetailsList: [],
      reasonTypeID: -1,
      amount: "",
      remark: "",
      fromDate: new Date("01 Jan 1900"),
      toDate: new Date("01 Jan 1900"),
      captchaValue: "",
      captchaKey: "",
      uploadedFile: [],
      bookingID: -1,
      userTypeID: -1,
      userType_List: [],
      userTypeIDForddl: -1,
      isDeleted: true,
      isDeletedint: 0,
      user_List: [],
      userIDForddl: -1,
      status: -1,
      fromDateAdmin: new Date("01 Jan 1900"),
      toDateAdmin: new Date("01 Jan 1900")
    };
  },
  methods: {
    generateCaptcha() {
      this.captchaValue = "";
      this.captchaKey = "";
      const _data_ = { width: 100, height: 30 };
      LoginJs.GenerateCaptcha(_data_).then(
        response => {
          $("#imgCaptcha").attr("src", response.data.result1);
          this.captchaKey = response.data.result;
          this.getReasonList();
        },
        error => {
          if (error.response.data.message != undefined) {
            alert(
              error.response.data.message +
                "\n" +
                error.response.data.exceptionMessage
            );
          } else {
            alert("Error: " + error.response.data);
          }
        },
        failure => {
          alert("Failure: " + failure.response);
        }
      );
    },
    getReasonList() {
      PaymentPortal.getReasonList().then(
        result => {
          this.reasonList = result.data;
          this.getTourOperatorPaymentDetailsList();
        },
        error => {},
        failure => {}
      );
    },
    validatePaymentRemark: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      var ok =
        (charCode >= 48 && charCode <= 57) ||
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 96 && charCode <= 105) ||
        (charCode >= 97 && charCode <= 122) ||
        charCode == 45 ||
        charCode == 32 ||
        charCode == 44 ||
        charCode == 47;
      if (!ok) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getTourOperatorPaymentDetailsList() {
      const _data = {
        TourOperatorPaymentID: -1,
        TourOperatorID: this.userIDForddl,
        TourOperatorTypeID: this.userTypeIDForddl,
        IsPaymentDone: this.status,
        FromDate: this.fromDateAdmin,
        ToDate: this.toDateAdmin
      };
      PaymentPortal.getTourOperatorPaymentDetailsList(_data).then(
        result => {
          // console.log(result.data);
          this.tourOperatorPaymentDetailsList = result.data;
          this.getUserType();
        },
        error => {},
        failure => {}
      );
    },
    getFileData(event) {
      var extFile = ["PDF", "JPG", "JPEG", "PNG"];
      var meFile = this;
      var myFile = [];

      var lstFile = event.target.files;
      var isValidFileExtension = true;
      var isValidFileSize = true;
      var isMinValidFileSize = true;
      var minCheckFileSize = parseFloat(10 * 1024);
      var checkFileSize = parseFloat(100 * 1024);

      for (var i = 0; i < lstFile.length; i++) {
        var fileName = lstFile[i].name;
        var fileExt = fileName.split(".").pop();
        if (!(extFile.indexOf(fileExt.toUpperCase()) >= 0)) {
          isValidFileExtension = false;
        }
        var filesize = lstFile[i].size;
        if (parseFloat(filesize) < minCheckFileSize) {
          isMinValidFileSize = false;
        }

        if (parseFloat(filesize) > checkFileSize) {
          isValidFileSize = false;
        }
        myFile.push(lstFile[i]);
      }

      if (isValidFileExtension == false) {
        alert("Unsupported media type.");
        event.target.value = "";
        return false;
      }
      if (isMinValidFileSize == false) {
        alert(
          "Individual files minimum size should be more than " +
            parseFloat(minCheckFileSize) / 1024 +
            " KB"
        );
        event.target.value = "";
        return false;
      }
      if (isValidFileSize == false) {
        alert(
          "Individual files size should be less than " +
            parseFloat(checkFileSize) / 1024 +
            " KB."
        );
        event.target.value = "";
        return false;
      }
      myFile.forEach(element => {
        var fileName = element.name;
        var fileExt = fileName.split(".").pop();
        var readerFile = new FileReader();
        readerFile.addEventListener("load", function(e) {
          var objectFile = new Object();
          objectFile.file = element;
          objectFile.filePreview = e.target.result;
          objectFile.docFileName = fileName;
          objectFile.percent = 0;
          objectFile.docFileID = "-1";
          objectFile.isUplodError = false;
          objectFile.isApproved = false;
          objectFile.ext = fileExt;
          meFile.uploadedFile.push(objectFile);
        });
        if (extFile.indexOf(fileExt.toUpperCase()) >= 0) {
          readerFile.readAsDataURL(element);
        }
      });
    },
    PayNow() {
      let msg = "";
      if (this.reasonTypeID == -1) {
        msg = "Please Select reason for Payment.";
      } else if (this.amount == "") {
        msg = "Please Enter Amount for Payment.";
      } else if (this.captchaValue == "") {
        msg = "Please Enter Captcha.\n";
      }
      if (msg != "") {
        MessageBox.show({
          message: msg,
          type: "error",
          title: "Error"
        });
        return false;
      }
      var file = "";
      var fileName = "";
      var fileExt = "";
      this.uploadedFile.forEach(function(item, index) {
        file = item.filePreview.split(",")[1];
        fileName = item.docFileName;
        fileExt = item.ext;
      });
      let list1 = [];
      list1.push({
        DocumentTypeID: -1,
        DocumentFile: file,
        DocumentFileExtension: fileExt,
        DocumentFileName: fileName,
        PurposeExplanation: ""
      });
      const BasicData = {
        TourOperatorPaymentID: -1,
        ReasonTypeID: this.reasonTypeID,
        PaymentAmount: this.amount,
        Remark: this.remark,
        PaymentFromDate: this.fromDate.convertToString("dd MMM yyyy"),
        PaymentToDate: this.toDate.convertToString("dd MMM yyyy"),
        CaptchaValue: this.captchaValue,
        CaptchaKey: this.captchaKey,
        TOPayDocList: list1
      };
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(BasicData));
      PaymentPortal.setTourOperatorPaymentDetails(formData).then(
        result => {
          // console.log(result.data);
          if (result.data.isSuccess) {
            this.bookingID = result.data.result;
            if (this.bookingID != -1) {
              this.$root.$data.BookingID = this.bookingID;
              this.$root.$data.isTourOperatorPayment = true;
              this.$router.push({ name: "TransRequest" });
            }
          } else {
            MessageBox.show({
              message: result.data.msg,
              type: "error",
              title: "Error"
            });
          }
        },
        error => {},
        failure => {}
      );
    },
    ClearPaymentDetails() {
      this.reasonTypeID = -1;
      this.amount = "";
      this.fromDate = new Date("01 Jan 1900");
      this.toDate = new Date("01 Jan 1900");
      this.remark = "";
      this.captchaValue = "";
    },
    fillUserData() {
      LoginJs.GetCurrentUser().then(
        response => {
          if (response.data) {
            this.userTypeID = response.data.userTypeID;
            this.generateCaptcha();
          }
        },
        error => {}
      );
    },
    getUserType() {
      this.userType_List = [];
      const _data_ = { isActive: -1, type: 1 };
      MasterEntryJS.getUserType(_data_).then(
        response => {
          this.userType_List = response.data;
          if (response.data.length > 0) {
            //console.log(this.userType_List);
            this.userType = 0;
          }
        },
        error => {}
      );
    },
    getUserList() {
      this.userIDForddl = -1;
      this.user_List = [];
      if (this.isDeleted) {
        this.isDeletedint = 0;
      } else {
        this.isDeletedint = 1;
      }

      const _data_ = {
        userTypeID: this.userTypeIDForddl,
        fromDate: new Date("01 Jan 1900"),
        toDate: new Date("01 Jan 1900"),
        isDeleted: this.isDeletedint,
        type: 2
      };
      UserManagementJS.getUserList(_data_).then(
        response => {
          if (response.data.length > 0) {
            this.user_List = response.data;
          }
          this.userID = -1;
        },
        error => {},
        failure => {}
      );
    },
    openScanImage(row) {
      if (row) {
        let imgURL;
        if (imgURL == "") {
          MessageBox.show({
            message: "Image Data Not Found",
            type: "error",
            title: "Error"
          });
        } else {
          var fileExt = row.documentFileExtension;
          var img = new Image();
          {
            this.windowPreview;
            if (this.windowPreview != null) {
              this.windowPreview.close();
            }
            this.windowPreview = window.open(
              "",
              "FilePreview",
              "scrollbars,addressbar=no,location=no,resizable=yes,width=550px,height=600px,left=10,top=10"
            );
            imgURL = "data:image/jpeg;base64," + row.documentFile;
            img.src = imgURL;
            this.windowPreview.document.write(img.outerHTML);
          }
        }
      }
    }
  },
  mounted() {
    this.fillUserData();
  }
};
</script>
<style>
.mandatorySpan {
  text-align: left;
  position: relative;
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.mandatorySpan.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 200%;
}
</style>



// WEBPACK FOOTER //
// src/components/PaymentPortal.vue